<template>
  <div id="valuation" class="fixed-content">
    <tabs :transition="0" v-model="tab">
      <tab title="Communications">
        <communications :congresses="sc.congresses">
        </communications>
      </tab>
      <tab title="Collaborations">
        <collaborations />
      </tab>
      <tab title="Publications">
        <publications :publications="sc.publications">
        </publications>
      </tab>
    </tabs>
  </div>
</template>
<script>
import collaborations from '@/components/valuation/collaborations'
import publications from '@/components/valuation/publications'
import communications from '@/components/valuation/communications'
import sc from '@/sc/valuation'

export default {
  components: { collaborations, publications, communications, sc },
  name: 'valuation',

  data () {
    const tab = parseInt(this.$route.query.tab)
    return {
      tab: (isNaN(tab)) ? 0 : tab,
      sc: sc
    }
  },

  watch: {
    '$route.query.tab': function (v) {
      const t = parseInt(v)
      this.tab = (isNaN(t)) ? 0 : t
    }
  }
}
</script>
